import { ILimitData } from '../request/response'
import { ILimit } from '../index'

export default function(item: ILimitData): ILimit {
  return {
    add: item.free_limitations_add_count,
    copy: item.free_limitations_copy_count,
    edit: item.free_limitations_edit_count,
    resetDate: new Date(Number(item.free_limitations_reset_date) * 1000),
    transfer: item.free_limitations_move_count,
  }
}
